import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { GuestSearchDrawer } from "./GuestSearchDrawer";

export const GuestSearch: React.FC<any> = React.memo((props) => {
    const [cartOpen, setCartOpen] = useState(false);
    const navigate = useNavigate()
    const handleCartClick = () => {
        setCartOpen(true);
    };
    
    const handleCartClose = () => {
        setCartOpen(false);
    };

    const columns: IColumns[] = [
        {
            header: "G. Code",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: "Name",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Address",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Contact No",
            fieldName: "address",
            tooltip: true,
        },
       
    ];

    const handleClick = (path:string) =>{
        navigate(path)
       }
     

    return (
        <Grid container direction="column"  sx={{ minHeight: '100vh' }}>
            {/* Header Section */}
            <Grid item>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
                    {/* Title on the left */}
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "green" }}>
                        Guest Search 
                    </Typography>
                    <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton>
                            <WSIcons.SyncIcon />
                        </IconButton>
                        <IconButton onClick={handleCartClick}>
                            <WSIcons.SearchIcon />
                        </IconButton>
                        <GuestSearchDrawer open={cartOpen} onClose={handleCartClose} />
                        <IconButton>
                            <WSIcons.CloseIcon sx={{ backgroundColor: 'red', color: 'white' }} onClick={()=>handleClick('/')}/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>

            {/* DataGrid Section */}
            <Grid item sx={{ flex: 1 }}>
                <WSDataGrid
                    id="itemGrid"
                    title=""
                    columns={columns}
                />
            </Grid>

            {/* Footer Section */}
            <Grid
  item
  sx={{
    backgroundColor: "#333",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Left-aligned items: icon and one button */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem", // space between icon and button
    }}
  >
    <WSIcons.GTranslateIcon sx={{ color: "white" }} />
    <Button
      variant="outlined"
      sx={{
        color: "white",
        borderColor: "green",
        "&:hover": {
          backgroundColor: "#2e7d32",
        },
      }}
      onClick={()=>handleClick('/delivery')}
    >
     Phone No
    </Button>
  </Grid>

  {/* Right-aligned items: two buttons */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem", // space between the buttons
    }}
  >
    <Button
      variant="outlined"
      sx={{
        color: "white",
        borderColor: "green",
        "&:hover": {
          backgroundColor: "#2e7d32",
        },
      }}
      onClick={()=>handleClick('/orderhistory')}

    >
      Show History
    </Button>
    <Button
      variant="contained"
      sx={{
        backgroundColor: "green",
        "&:hover": {
          backgroundColor: "#388e3c",
        },
      }}
    >
      Finish
    </Button>
  </Grid>
</Grid>

        </Grid>
    );
});
